<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <i class="fa fa-bug"></i> {{ $t('faultDetectionChat') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('await')"></b-tab>
          <b-tab :title="$t('locked')"></b-tab>
          <b-tab :title="$t('skip')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1" @input="load"></client-select>

            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-5">{{ $t('client') }}</div>
            <div class="col-lg-5">{{ $t('hangupCause') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-5">
              {{ item.client.companyName }} ({{ item.client.domain }})
              <span v-if="!item.client.active" class="badge badge-danger">{{ $t('locked') }}</span>
            </div>
            <div class="col-lg-7">
              <div v-if="item.approveTime">
                <b>{{ $t('approveTime') }}: </b> {{ item.approveTime  | moment('DD/MM/YYYY HH:mm:ss') }}
                <span v-if="item.approveBy" class="ml-2"><b>{{ $t('by') }}: </b> {{ item.approveBy.name }}</span>
              </div>
              <div v-if="item.cancelTime">
                <b>{{ $t('cancelTime') }}: </b> {{ item.cancelTime  | moment('DD/MM/YYYY HH:mm:ss') }}
                <span v-if="item.cancelBy" class="ml-2"><b>{{ $t('by') }}: </b> {{ item.cancelBy.name }}</span>
              </div>
              <chat-detail :id="item._id" :count="item.messages.length"></chat-detail>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from '../../mixins/List'
import CRUD from '../../mixins/CRUD'
import ClientSelect from '../../components/ClientSelect'
import ChatDetail from '@/views/fault-detection/ChatDetail.vue'

export default {
  components: { ClientSelect, ChatDetail },
  mixins: [List, CRUD],
  data: function() {
    return {
      saveLoading: false,
      service: '/fault-detection-chat',
      reloadBus: 'faultDetectionChat',
      defaultFilterFormModel: {
        status: 0,
        keyword: null
      }
    }
  },
  i18n: {
    messages: {
      en: {
        faultDetectionChat: 'Suspicious chat',
        await: 'Await',
        skip: 'Skip',
        cancelTime: 'Cancel time',
        by: 'by',
        hangupCause: 'End status'
      },
      vi: {
        faultDetectionChat: 'Tin nhắn nghi ngờ vi phạm',
        await: 'Chờ kiểm tra',
        skip: 'Bỏ qua',
        cancelTime: 'Bỏ qua lúc',
        by: 'bởi',
        hangupCause: 'Kết quả'
      }
    }
  }
}
</script>